module.exports = __webpack_public_path__ + "images/headerAdorama5221f36850614541850d955415cb2c6c.png";